import { render, staticRenderFns } from "./CreateGroupModalOrderList.vue?vue&type=template&id=1faefaf8"
import script from "./CreateGroupModalOrderList.vue?vue&type=script&lang=js"
export * from "./CreateGroupModalOrderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports